import { useEffect } from 'react';
import { useSession } from './api/session';
import { needsLogin } from './sessionGate';
import { useAppStore } from './store/appStore';
import { useRunStore } from './store/runStore';
import { EditorScreen } from './ui/EditorScreen';
import { LoginScreen } from './ui/LoginScreen';
import { RunScreen } from './ui/RunScreen';
import { StartScreen } from './ui/StartScreen';
import { UsersScreen } from './ui/UsersScreen';

export function App() {
  const screen = useAppStore((s) => s.screen);
  const sessionState = useSession((s) => s.state);
  const isAdmin = useSession((s) => s.user?.role === 'admin');
  const refresh = useSession((s) => s.refresh);
  const hasRun = useRunStore((s) => s.run !== null);
  useEffect(() => {
    refresh();
  }, [refresh]);

  if (sessionState === 'loading') {
    return (
      <div className="flex h-full items-center justify-center text-sm text-neutral-400">
        Wird geladen …
      </div>
    );
  }
  if (needsLogin(sessionState, screen, hasRun)) return <LoginScreen />;
  // The editor and the user list are admin screens. After an expired session the screen state
  // survives the login screen, so an instructor signing in there must land on the start screen.
  if (screen === 'editor' && isAdmin) return <EditorScreen />;
  if (screen === 'run') return <RunScreen />;
  if (screen === 'users' && isAdmin) return <UsersScreen />;
  return <StartScreen />;
}
